/**
 * @generated SignedSource<<36d827ba218a5d74c8e95e62ac0609fe>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type PnlLineDrillEnum = "AFTER_DISTRIBUTIONS" | "COGS" | "DEBT_OUTSTANDING" | "DISTRIBUTIONS" | "EBITDA" | "GROSS_PROFIT" | "G_AND_A" | "INTEREST_AND_FEES" | "LOAN_PRINCIPAL_REPAID" | "LOAN_PROCEEDS" | "OTHER_OPEX" | "REVENUE" | "R_AND_D" | "S_AND_M" | "TAXES" | "TAX_PAID" | "UNCATEGORIZED" | "%future added value";
export type TxnClassificationEnum = "CHARGEBACK" | "DIVIDEND" | "FINANCING_FEE" | "FRAUDULENT" | "LOAN_PROCEEDS" | "LOAN_REPAYMENT" | "PROCESSOR_FEE" | "REFUND" | "SALARY" | "TAX_PAYMENT" | "TAX_REFUND" | "%future added value";
export type TxnFlowEnum = "COST" | "INTERNAL" | "REVENUE" | "%future added value";
export type TxnSortEnum = "ACCOUNT" | "AMOUNT" | "CATEGORY" | "COUNTERPARTY" | "DATE" | "DESCRIPTION" | "NATURE" | "%future added value";
export type transactionsPage_Query$variables = {
  accountNumber?: string | null | undefined;
  attributed?: boolean | null | undefined;
  categorized?: boolean | null | undefined;
  counterpartyId?: string | null | undefined;
  dailyHealth?: boolean | null | undefined;
  excludeNeedsReview?: boolean | null | undefined;
  flow?: TxnFlowEnum | null | undefined;
  from?: string | null | undefined;
  limit?: number | null | undefined;
  month?: string | null | undefined;
  natureId?: string | null | undefined;
  offset?: number | null | undefined;
  perspectiveId?: string | null | undefined;
  pnlLine?: PnlLineDrillEnum | null | undefined;
  query?: string | null | undefined;
  sort?: TxnSortEnum | null | undefined;
  sortDirection?: string | null | undefined;
};
export type transactionsPage_Query$data = {
  readonly allStakeholders: ReadonlyArray<{
    readonly id: string;
    readonly name: string;
  }>;
  readonly bankAccounts: ReadonlyArray<{
    readonly id: string;
    readonly last4: string | null | undefined;
    readonly name: string;
    readonly nickname: string;
    readonly number: string;
  }>;
  readonly categories: ReadonlyArray<{
    readonly id: string;
    readonly name: string;
    readonly parent: {
      readonly id: string;
    } | null | undefined;
  }>;
  readonly expenseNatures: ReadonlyArray<{
    readonly id: string;
    readonly name: string;
  }>;
  readonly transactions: {
    readonly accounts: ReadonlyArray<{
      readonly nickname: string | null | undefined;
      readonly number: string;
    }>;
    readonly health: ReadonlyArray<{
      readonly categorized: number;
      readonly internal: number;
      readonly period: string;
      readonly uncategorized: number;
    }>;
    readonly limit: number;
    readonly months: ReadonlyArray<string>;
    readonly totalCount: number;
    readonly txns: ReadonlyArray<{
      readonly accountNumber: string | null | undefined;
      readonly amount: number;
      readonly attribution: {
        readonly performedAt: string | null | undefined;
        readonly rule: {
          readonly regex: string;
        } | null | undefined;
        readonly source: string;
        readonly user: {
          readonly email: string | null | undefined;
        } | null | undefined;
      } | null | undefined;
      readonly categoryNode: {
        readonly id: string;
        readonly name: string;
      } | null | undefined;
      readonly classification: TxnClassificationEnum | null | undefined;
      readonly counterparty: {
        readonly id: string;
        readonly name: string;
      } | null | undefined;
      readonly description: string;
      readonly expenseNature: {
        readonly id: string;
        readonly name: string;
      } | null | undefined;
      readonly internal: boolean;
      readonly kind: string;
      readonly otherBankAccount: {
        readonly last4: string | null | undefined;
        readonly nickname: string;
      } | null | undefined;
      readonly postingDate: string;
      readonly txn: {
        readonly id: string;
      };
    }>;
  };
};
export type transactionsPage_Query = {
  response: transactionsPage_Query$data;
  variables: transactionsPage_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "accountNumber"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "attributed"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "categorized"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "counterpartyId"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "dailyHealth"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "excludeNeedsReview"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "flow"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "from"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "limit"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "month"
},
v10 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "natureId"
},
v11 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "offset"
},
v12 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "perspectiveId"
},
v13 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "pnlLine"
},
v14 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "query"
},
v15 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sort"
},
v16 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sortDirection"
},
v17 = {
  "kind": "Variable",
  "name": "perspectiveId",
  "variableName": "perspectiveId"
},
v18 = [
  {
    "kind": "Variable",
    "name": "accountNumber",
    "variableName": "accountNumber"
  },
  {
    "kind": "Variable",
    "name": "attributed",
    "variableName": "attributed"
  },
  {
    "kind": "Variable",
    "name": "categorized",
    "variableName": "categorized"
  },
  {
    "kind": "Variable",
    "name": "counterpartyId",
    "variableName": "counterpartyId"
  },
  {
    "kind": "Variable",
    "name": "dailyHealth",
    "variableName": "dailyHealth"
  },
  {
    "kind": "Variable",
    "name": "excludeNeedsReview",
    "variableName": "excludeNeedsReview"
  },
  {
    "kind": "Variable",
    "name": "flow",
    "variableName": "flow"
  },
  {
    "kind": "Variable",
    "name": "from",
    "variableName": "from"
  },
  {
    "kind": "Variable",
    "name": "limit",
    "variableName": "limit"
  },
  {
    "kind": "Variable",
    "name": "month",
    "variableName": "month"
  },
  {
    "kind": "Variable",
    "name": "natureId",
    "variableName": "natureId"
  },
  {
    "kind": "Variable",
    "name": "offset",
    "variableName": "offset"
  },
  (v17/*: any*/),
  {
    "kind": "Variable",
    "name": "pnlLine",
    "variableName": "pnlLine"
  },
  {
    "kind": "Variable",
    "name": "query",
    "variableName": "query"
  },
  {
    "kind": "Variable",
    "name": "sort",
    "variableName": "sort"
  },
  {
    "kind": "Variable",
    "name": "sortDirection",
    "variableName": "sortDirection"
  }
],
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "limit",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "months",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "number",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nickname",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "period",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "categorized",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "uncategorized",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "internal",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v29 = [
  (v28/*: any*/)
],
v30 = {
  "alias": null,
  "args": null,
  "concreteType": "Txn",
  "kind": "LinkedField",
  "name": "txn",
  "plural": false,
  "selections": (v29/*: any*/),
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "postingDate",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "amount",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "kind",
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "accountNumber",
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "last4",
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "classification",
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v39 = [
  (v28/*: any*/),
  (v38/*: any*/)
],
v40 = {
  "alias": null,
  "args": null,
  "concreteType": "ExpenseNature",
  "kind": "LinkedField",
  "name": "expenseNature",
  "plural": false,
  "selections": (v39/*: any*/),
  "storageKey": null
},
v41 = {
  "alias": null,
  "args": null,
  "concreteType": "Stakeholder",
  "kind": "LinkedField",
  "name": "counterparty",
  "plural": false,
  "selections": (v39/*: any*/),
  "storageKey": null
},
v42 = {
  "alias": null,
  "args": null,
  "concreteType": "Category",
  "kind": "LinkedField",
  "name": "categoryNode",
  "plural": false,
  "selections": (v39/*: any*/),
  "storageKey": null
},
v43 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "source",
  "storageKey": null
},
v44 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "performedAt",
  "storageKey": null
},
v45 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v46 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "regex",
  "storageKey": null
},
v47 = {
  "alias": null,
  "args": null,
  "concreteType": "Stakeholder",
  "kind": "LinkedField",
  "name": "allStakeholders",
  "plural": true,
  "selections": (v39/*: any*/),
  "storageKey": null
},
v48 = {
  "alias": null,
  "args": null,
  "concreteType": "BankAccount",
  "kind": "LinkedField",
  "name": "bankAccounts",
  "plural": true,
  "selections": [
    (v28/*: any*/),
    (v38/*: any*/),
    (v23/*: any*/),
    (v36/*: any*/),
    (v22/*: any*/)
  ],
  "storageKey": null
},
v49 = [
  (v17/*: any*/)
],
v50 = {
  "alias": null,
  "args": (v49/*: any*/),
  "concreteType": "Category",
  "kind": "LinkedField",
  "name": "categories",
  "plural": true,
  "selections": [
    (v28/*: any*/),
    (v38/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Category",
      "kind": "LinkedField",
      "name": "parent",
      "plural": false,
      "selections": (v29/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v51 = {
  "alias": null,
  "args": (v49/*: any*/),
  "concreteType": "ExpenseNature",
  "kind": "LinkedField",
  "name": "expenseNatures",
  "plural": true,
  "selections": (v39/*: any*/),
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/),
      (v13/*: any*/),
      (v14/*: any*/),
      (v15/*: any*/),
      (v16/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "transactionsPage_Query",
    "selections": [
      {
        "alias": null,
        "args": (v18/*: any*/),
        "concreteType": "TransactionsPage",
        "kind": "LinkedField",
        "name": "transactions",
        "plural": false,
        "selections": [
          (v19/*: any*/),
          (v20/*: any*/),
          (v21/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "FilterAccount",
            "kind": "LinkedField",
            "name": "accounts",
            "plural": true,
            "selections": [
              (v22/*: any*/),
              (v23/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "CategorizationHealthMonth",
            "kind": "LinkedField",
            "name": "health",
            "plural": true,
            "selections": [
              (v24/*: any*/),
              (v25/*: any*/),
              (v26/*: any*/),
              (v27/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "TransactionRow",
            "kind": "LinkedField",
            "name": "txns",
            "plural": true,
            "selections": [
              (v30/*: any*/),
              (v31/*: any*/),
              (v32/*: any*/),
              (v33/*: any*/),
              (v34/*: any*/),
              (v35/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "BankAccount",
                "kind": "LinkedField",
                "name": "otherBankAccount",
                "plural": false,
                "selections": [
                  (v23/*: any*/),
                  (v36/*: any*/)
                ],
                "storageKey": null
              },
              (v27/*: any*/),
              (v37/*: any*/),
              (v40/*: any*/),
              (v41/*: any*/),
              (v42/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Attribution",
                "kind": "LinkedField",
                "name": "attribution",
                "plural": false,
                "selections": [
                  (v43/*: any*/),
                  (v44/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": [
                      (v45/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Rule",
                    "kind": "LinkedField",
                    "name": "rule",
                    "plural": false,
                    "selections": [
                      (v46/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      (v47/*: any*/),
      (v48/*: any*/),
      (v50/*: any*/),
      (v51/*: any*/)
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v9/*: any*/),
      (v7/*: any*/),
      (v0/*: any*/),
      (v6/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v12/*: any*/),
      (v3/*: any*/),
      (v10/*: any*/),
      (v13/*: any*/),
      (v14/*: any*/),
      (v15/*: any*/),
      (v16/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v8/*: any*/),
      (v11/*: any*/)
    ],
    "kind": "Operation",
    "name": "transactionsPage_Query",
    "selections": [
      {
        "alias": null,
        "args": (v18/*: any*/),
        "concreteType": "TransactionsPage",
        "kind": "LinkedField",
        "name": "transactions",
        "plural": false,
        "selections": [
          (v19/*: any*/),
          (v20/*: any*/),
          (v21/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "FilterAccount",
            "kind": "LinkedField",
            "name": "accounts",
            "plural": true,
            "selections": [
              (v22/*: any*/),
              (v23/*: any*/),
              (v28/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "CategorizationHealthMonth",
            "kind": "LinkedField",
            "name": "health",
            "plural": true,
            "selections": [
              (v24/*: any*/),
              (v25/*: any*/),
              (v26/*: any*/),
              (v27/*: any*/),
              (v28/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "TransactionRow",
            "kind": "LinkedField",
            "name": "txns",
            "plural": true,
            "selections": [
              (v30/*: any*/),
              (v31/*: any*/),
              (v32/*: any*/),
              (v33/*: any*/),
              (v34/*: any*/),
              (v35/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "BankAccount",
                "kind": "LinkedField",
                "name": "otherBankAccount",
                "plural": false,
                "selections": [
                  (v23/*: any*/),
                  (v36/*: any*/),
                  (v28/*: any*/)
                ],
                "storageKey": null
              },
              (v27/*: any*/),
              (v37/*: any*/),
              (v40/*: any*/),
              (v41/*: any*/),
              (v42/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Attribution",
                "kind": "LinkedField",
                "name": "attribution",
                "plural": false,
                "selections": [
                  (v43/*: any*/),
                  (v44/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": [
                      (v45/*: any*/),
                      (v28/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Rule",
                    "kind": "LinkedField",
                    "name": "rule",
                    "plural": false,
                    "selections": [
                      (v46/*: any*/),
                      (v28/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v28/*: any*/)
                ],
                "storageKey": null
              },
              (v28/*: any*/)
            ],
            "storageKey": null
          },
          (v28/*: any*/)
        ],
        "storageKey": null
      },
      (v47/*: any*/),
      (v48/*: any*/),
      (v50/*: any*/),
      (v51/*: any*/)
    ]
  },
  "params": {
    "cacheID": "40821cf9565c920ba49b9e09172c92d3",
    "id": null,
    "metadata": {},
    "name": "transactionsPage_Query",
    "operationKind": "query",
    "text": "query transactionsPage_Query(\n  $month: String\n  $from: String\n  $accountNumber: String\n  $flow: TxnFlowEnum\n  $attributed: Boolean\n  $categorized: Boolean\n  $perspectiveId: ID\n  $counterpartyId: ID\n  $natureId: ID\n  $pnlLine: PnlLineDrillEnum\n  $query: String\n  $sort: TxnSortEnum\n  $sortDirection: String\n  $dailyHealth: Boolean\n  $excludeNeedsReview: Boolean\n  $limit: Int\n  $offset: Int\n) {\n  transactions(month: $month, from: $from, accountNumber: $accountNumber, flow: $flow, attributed: $attributed, categorized: $categorized, perspectiveId: $perspectiveId, counterpartyId: $counterpartyId, natureId: $natureId, pnlLine: $pnlLine, query: $query, sort: $sort, sortDirection: $sortDirection, dailyHealth: $dailyHealth, excludeNeedsReview: $excludeNeedsReview, limit: $limit, offset: $offset) {\n    totalCount\n    limit\n    months\n    accounts {\n      number\n      nickname\n      id\n    }\n    health {\n      period\n      categorized\n      uncategorized\n      internal\n      id\n    }\n    txns {\n      txn {\n        id\n      }\n      postingDate\n      description\n      amount\n      kind\n      accountNumber\n      otherBankAccount {\n        nickname\n        last4\n        id\n      }\n      internal\n      classification\n      expenseNature {\n        id\n        name\n      }\n      counterparty {\n        id\n        name\n      }\n      categoryNode {\n        id\n        name\n      }\n      attribution {\n        source\n        performedAt\n        user {\n          email\n          id\n        }\n        rule {\n          regex\n          id\n        }\n        id\n      }\n      id\n    }\n    id\n  }\n  allStakeholders {\n    id\n    name\n  }\n  bankAccounts {\n    id\n    name\n    nickname\n    last4\n    number\n  }\n  categories(perspectiveId: $perspectiveId) {\n    id\n    name\n    parent {\n      id\n    }\n  }\n  expenseNatures(perspectiveId: $perspectiveId) {\n    id\n    name\n  }\n}\n"
  }
};
})();

(node as any).hash = "35da154a6a2ae40233656ffbd2415c39";

export default node;
